import React, { useState } from 'react';

import './SlidePicker.css'

export default function SlidePicker(props) {
  const [value, setValue] = useState(props.settings[props?.value ?? 0])
  const [index, setIndex] = useState(props?.value ?? 0);

  const handleIncrement = () => {
    console.log (index)
    const nextIndex = index + 1 >= props.settings.length ? 0 : index+1
    handleUpdate(nextIndex)
  };
  const handleUpdate = (newIndex) => {
    props?.onUpdate (props.settings[newIndex])
    setIndex(newIndex);
    setValue(props.settings[newIndex])
  }
  return (
    <span>
      <input className="slide-value" type='text' readOnly placeholder={value} /> 
      <button className="slide-btn" onClick={handleIncrement}>&gt;</button>
    </span>
  );
}
